import Panel from '@/components/Panel'
import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { EyeOutlined } from '@ant-design/icons';
import { Tooltip, Input, Select, Button, Spin, Popover, Flex } from 'antd';
import endToEndChannelConstructor from '@/services/Andes_v2/endToEndChannel/endToEndChannelConstructor'
import { CPHY, PCIE } from '../../../../../services/PCBHelper/constants';
import { getReportGuideKeys } from '../../../../../services/helper/reportHelper';
import ReferenceLines from '../../../../../components/ReferenceLine';
import { REFERENCE_LINE } from '../../../../../constants/libraryConstants.js';
import libraryConstructor from '../../../../../services/Andes_v2/library/libraryConstructor.js';
import { getLibraryDetail } from '../../../../../services/Andes_v2/library/libraryCtrl.js';
import { importCustomConfig, getDefaultGuideValue, getReferenceLinesOptionsData, exportCustomConfig } from '../../../../../services/Andes_v2/results/sparameter/dataHelper.js';
import { checkNameFormat } from '../../../../../services/helper/nameFormatCheck.js';
import { getLibraryListByType } from '../../../../../services/PreLayout/PreLayoutLibrary/libraryHelper.js';
import { getDefaultName } from '../../../../../services/helper/setDefaultName.js';
import './index.css';

const defaultGuideKey = getReportGuideKeys('andes_v2_reference_line');
const defaultCPHYGuideKey = getReportGuideKeys('andes_v2_CPHY_reference_line');

class ResultReference extends Component {
  constructor(props) {
    super(props);
    const { reportConfig } = props;
    const { symbolRate = 2.5, fh, fMax, fINTMin = 0.45, fLPMax = 0.01, driver = [], receiver = [], dataRate, guideValue = [] } = reportConfig && reportConfig.custom ? reportConfig.custom : {};
    this.state = {
      tableData: [],
      error: '',
      symbolRate,
      frequency: {
        fh: fh || symbolRate * 0.5,
        fMax: fMax || symbolRate * 0.75,
        fINTMin,
        fLPMax
      },
      driver,
      receiver,
      dataRate: dataRate ? dataRate : (guideValue[0] || {}).dataRate || 16,
      importId: "",
      exportName: "",
      exportNameError: "",
      loading: false,
      referenceLinesOptions: []
    }

    this.dialogRoot = document.getElementById('root');
    this.referenceLinesRef = null;
  }

  componentDidMount = () => {
    const { defaultTableData, interfaceType } = this.props;
    this.setState({
      tableData: defaultTableData,
      referenceLinesOptions: getReferenceLinesOptionsData(libraryConstructor.getLibraryValues(REFERENCE_LINE), interfaceType)
    });

  }
  componentDidUpdate(prevProps) {
    const { libraryStatus, interfaceType } = this.props;
    if (prevProps.libraryStatus !== libraryStatus) {
      this.setState({
        referenceLinesOptions: getReferenceLinesOptionsData(libraryConstructor.getLibraryValues(REFERENCE_LINE), interfaceType)
      })
    }
  }

  changeResultData = (_tableData, _isXTable, inputType) => {
    this.changeReferenceLineData(_tableData, _isXTable)
    this.props.crossReferenceLine(_tableData, inputType);
  }

  closePanel = () => {
    const { projectId, id } = this.props;
    const { errorMsg } = this.referenceLinesRef.state;
    if (errorMsg && Object.keys(errorMsg)) {
      for (const key of Object.keys(errorMsg)) {
        if (errorMsg[key]) return;
      }
    }
    const endToEndList = endToEndChannelConstructor.getEndToEndChannelValues(projectId) || [];
    let isMultiPCB = false;
    if (endToEndList.find(item => item.id === id)) {
      isMultiPCB = true;
    }
    if (!id) { return }
    this.props.saveReportConfig(id, isMultiPCB);
    this.props.closePanel();
  }

  changeReferenceLineData = (data, isXTable) => {
    const { symbolRate, frequency, dataRate } = this.state;
    const { reportConfig, interfaceType } = this.props;
    let config = { ...reportConfig };
    const _defaultGuideKey = interfaceType === CPHY ? defaultCPHYGuideKey : defaultGuideKey
    if (config && config.custom) {
      config.custom.guideValue = config.custom.guideValue.map(item => {
        if (_defaultGuideKey.indexOf(item.name) !== -1) {
          return data[_defaultGuideKey.indexOf(item.name)]
        } else {
          return item
        }
      })
      config.custom.isXTable = isXTable;
      if (interfaceType === CPHY) {
        config.custom.symbolRate = symbolRate;
        for (const key of Object.keys(frequency)) {
          config.custom[key] = frequency[key];
        }
      } else if (interfaceType === PCIE) {
        config.custom.dataRate = dataRate;
      }
    }
    this.props.updateReportInfo({ reportConfig: config });
  }

  changeConfigs = (_tableData, { symbolRate, driver, receiver, frequency, dataRate }, pointType, pointTypes) => {
    const { reportConfig, interfaceType } = this.props;
    let config = { ...reportConfig };
    if (config && config.custom) {
      if (interfaceType === CPHY) {
        config.custom.symbolRate = Number(symbolRate);
        config.custom.driver = driver;
        config.custom.receiver = receiver;
        for (const key of Object.keys(frequency)) {
          config.custom[key] = Number(frequency[key]);
        }
      } else if (interfaceType === PCIE) {
        config.custom.dataRate = Number(dataRate);
      }
    }
    this.props.updateReportInfo({ reportConfig: config });
    this.props.crossReferenceLine(_tableData, pointType === 'points' && pointTypes.length > 1 ? pointTypes : pointType);
  }

  titleRender = (tableData) => {
    const { isShowReferenceLine, changeIsShowReferenceLine } = this.props;
    return (
      <div className='result-reference-header'>
        <span>
          <span className='result-reference-title'>Reference Lines</span>
          <Tooltip title="Display line and mask" classNames={{ root: 'aurora-tooltip' }}>
            <EyeOutlined
              className='result-reference-icon'
              style={{ color: isShowReferenceLine ? '#1890ff' : undefined }}
              onClick={() => changeIsShowReferenceLine(tableData)} />
          </Tooltip>
        </span>
      </div>
    );
  }

  changeTableData = (tableData) => {
    this.setState({ tableData })
  }

  exportOrImport = (key, importId) => {
    const { importId: prevImportId } = this.state;
    const { reportConfig, dataRate, interfaceType } = this.props;

    if (key === 'import') {
      this.setState({ importLoading: true, importId });
      if (importId) {
        getLibraryDetail(importId).then(res => {
          if (res) {
            const { config } = res;
            const _reportConfig = {
              ...reportConfig,
              custom: importCustomConfig(reportConfig.custom, config, interfaceType)
            };
            this.props.updateReportInfo({ reportConfig: _reportConfig });
            const guideValue = _reportConfig.custom.guideValue;
            const tableData = getDefaultGuideValue(interfaceType === CPHY ? 'andes_v2_CPHY' : 'andes_v2', dataRate, guideValue);
            this.setState({
              tableData,
              ...(interfaceType === CPHY ? {
                symbolRate: _reportConfig.custom.symbolRate,
                frequency: {
                  fh: _reportConfig.custom.fh,
                  fMax: _reportConfig.custom.fMax,
                  fINTMin: _reportConfig.custom.fINTMin,
                  fLPMax: _reportConfig.custom.fLPMax
                }
              }
                : interfaceType === PCIE ? { dataRate: _reportConfig.custom.dataRate }
                  : {})
            })

            this.changeResultData(tableData, _reportConfig.custom.isXTable)
          }
          this.setState({ importLoading: false })
        }).catch(() => {
          this.setState({ importLoading: false })
        })
        return;
      } else if (prevImportId && !importId) {
        // clear data
        const tableData = getDefaultGuideValue(interfaceType === CPHY ? 'andes_v2_CPHY' : 'andes_v2', dataRate, []);
        this.setState({
          tableData,
          importLoading: false,
          ...(interfaceType === CPHY ? {
            symbolRate: 2.5,
            frequency: {
              fh: 1.25,
              fMax: 1.875,
              fINTMin: 0.45,
              fLPMax: 0.01
            }
          }
            : interfaceType === PCIE ? { dataRate: 16 }
              : {})
        })
        this.changeResultData(tableData, false)
      }
    } else {
      const { exportName } = this.state;
      let error = checkNameFormat(exportName);
      if (!error) {
        const referenceLineList = libraryConstructor.getLibraryValues(REFERENCE_LINE);
        const libraryNames = referenceLineList.map(item => item.name);
        if (libraryNames.includes(exportName)) {
          error = "The name already exists, please enter another name."
        }
      }
      if (error) {
        this.setState({ exportNameError: error });
        return;
      }
      this.setState({ exportLoading: true });
      const _defaultGuideKey = interfaceType === CPHY ? defaultCPHYGuideKey : defaultGuideKey
      this.props.updateLibraryData(
        REFERENCE_LINE,
        {
          id: "",
          name: exportName,
          type: REFERENCE_LINE,
          config: exportCustomConfig(reportConfig.custom, _defaultGuideKey, interfaceType),
          tag: interfaceType,
          version: "0.0.1"
        }
      )
      setTimeout(() => {
        this.setState({
          exportLoading: false,
          exportOpen: false
        })
      }, 1000)
    }
  }

  changeExportOpen = (open) => {
    const { importId } = this.state;
    let exportName = "";
    if (open) {
      if (importId) {
        const referenceLineList = libraryConstructor.getLibraryValues(REFERENCE_LINE);
        const { name } = referenceLineList.find(item => item.id === importId) || {};
        exportName = name + "_new";
      } else {
        const { libraryList, libraryName } = getLibraryListByType(REFERENCE_LINE, libraryConstructor);
        exportName = getDefaultName({ nameList: libraryList, defaultKey: libraryName });
      }
    }

    this.setState({ exportOpen: open, exportName });
  }

  exportPopoverContent = () => {
    const { exportNameError, exportName, exportLoading } = this.state;
    return <div className='result-reference-export-box'>
      <Input
        value={exportName}
        onChange={(e) => this.setState({ exportName: e.target.value })}
        placeholder='Name'
        className='aurora-input result-reference-export-input'
      />
      {exportNameError ? <div className='andes-v2-name-error-text'>{exportNameError}</div> : null}
      <Flex wrap gap="small" justify='flex-end'>
        <Button
          size="small"
          onClick={() => this.changeExportOpen(false)}
        >
          Cancel
        </Button>
        <Button
          size="small"
          type='primary'
          onClick={() => this.exportOrImport("export")}
          loading={exportLoading}
        >
          Save
        </Button>
      </Flex>
    </div>
  }

  exportAndImprotRender = () => {
    const { referenceLinesOptions, importId, exportOpen } = this.state;
    return <div className='result-reference-export-import-box'>
      <div className='result-reference-item'>
        <label>Reference Lines Spec</label>
        <Select
          allowClear
          className='aurora-select result-reference-item-select'
          popupClassName='aurora-select-dropdown'
          value={importId}
          onChange={(value) => this.exportOrImport("import", value)}
          options={referenceLinesOptions}
        />
      </div>
      <div className='result-reference-item'>
        <Popover
          trigger="click"
          classNames={{ root: "aurora-popover" }}
          open={exportOpen}
          content={this.exportPopoverContent()}
          getPopupContainer={trigger => trigger.parentNode}
        >
          <Button
            size='small'
            className='result-reference-button'
            onClick={() => this.changeExportOpen(true)}
          >
            Save To Library
          </Button>
        </Popover>
      </div>
    </div>
  }

  changeSettingInfo = (settingInfo) => {
    this.setState({ ...settingInfo });
  }

  render() {
    const { tableData, symbolRate, frequency, receiver, driver, loading, dataRate } = this.state;
    const { interfaceType, reportConfig, components } = this.props;
    let width = 800, guideKey = defaultGuideKey
    if (interfaceType === CPHY) {
      width = 1200;
      guideKey = defaultCPHYGuideKey;
    }

    const content = (<Panel
      className='result-reference-panel'
      title={this.titleRender(tableData)}
      width={width}
      draggable
      minHeight={500}
      zIndex={3000}
      position='panel-center'
      onCancel={() => this.closePanel()}
    >
      <Spin spinning={loading}>
        <ReferenceLines
          ref={ref => this.referenceLinesRef = ref}
          type="Result"
          tableData={tableData}
          interfaceType={interfaceType}
          guideValue={reportConfig && reportConfig.custom && reportConfig.custom.guideValue ? reportConfig.custom.guideValue : []}
          guideKey={guideKey}
          isXTable={reportConfig && reportConfig.custom && typeof reportConfig.custom.isXTable === 'boolean' ? reportConfig.custom.isXTable : false}
          dataRate={dataRate}
          symbolRate={symbolRate}
          driver={driver}
          receiver={receiver}
          frequency={frequency}
          components={components}
          changeTableData={this.changeTableData}
          changeConfigs={this.changeConfigs}
          changeSettingInfo={this.changeSettingInfo}
          changeResultData={this.changeResultData}
        >
          {this.exportAndImprotRender()}
        </ReferenceLines>
      </Spin>

    </Panel>)
    return createPortal(content, this.dialogRoot);
  }
}

export default ResultReference;